// extracted by mini-css-extract-plugin
export default {"baseCard":"styles_baseCard_KDRCS"};